import type { ReactElement } from 'react'

export function CloudWash(): ReactElement {
  return (
    <svg
      className="lp-cloud-wash"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      preserveAspectRatio="none"
    >
      <defs>
        <filter
          id="cloud"
          x="0%"
          y="0%"
          width="100%"
          height="100%"
          colorInterpolationFilters="sRGB"
        >
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.012 0.008"
            numOctaves={5}
            seed={4}
            stitchTiles="stitch"
            result="turb"
          />
          <feColorMatrix type="saturate" values="0" in="turb" result="bw" />
          <feComponentTransfer in="bw" result="clouds">
            <feFuncR type="discrete" tableValues="0.76 0.78 0.80 0.83 0.86 0.89 0.92 0.95" />
            <feFuncG type="discrete" tableValues="0.78 0.80 0.82 0.85 0.87 0.90 0.93 0.95" />
            <feFuncB type="discrete" tableValues="0.84 0.86 0.88 0.90 0.92 0.94 0.96 0.97" />
            <feFuncA type="table" tableValues="0.7 0.65 0.6 0.55 0.5 0.55 0.6 0.65 0.7" />
          </feComponentTransfer>
          <feGaussianBlur in="clouds" stdDeviation={3} />
        </filter>
      </defs>
      <rect width="100%" height="100%" filter="url(#cloud)" />
    </svg>
  )
}
